module.exports = __webpack_public_path__ + "img/yk@2x.e91c1ff0.png";